// extracted by mini-css-extract-plugin
module.exports = {"image":"MapView_image__x6aOg"};